import React from 'react'
import styles from './header.module.css'
import { Link } from 'react-router-dom'
import { Row, Col } from 'react-bootstrap'
// import CartIcon from '../shop/cartIcon'

function Header() {
  return (
    <header data-testid="desktop-header" className={styles.desktopHeader}>
      <Row>
        <Col></Col>
        <Col className="text-center">
          <Link to="/">
            <h1 className={styles.title}>BigMochi</h1>
          </Link>
        </Col>
        <Col className="text-right">{/* <CartIcon /> */}</Col>
      </Row>
    </header>
  )
}

export default Header
